import { render, staticRenderFns } from "./-new-button.vue?vue&type=template&id=b0717c5a&"
import script from "./-new-button.vue?vue&type=script&lang=js&"
export * from "./-new-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports